<template>
  <div
    class="tab-pane fade active show"
    id="willProcessDisaster-content"
    role="tabpanel"
    aria-labelledby="willProcessDisaster-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">風景區</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option
              v-for="(list, index) in weatherStationScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <div class="col-md-2">
          <label for="inputEmail4" class="form-label">通報項目</label>
          <select class="form-control" v-model.number="selectType">
            <option value="-1">全部</option>
            <option
              v-for="(type, index) in typeList"
              :key="index"
              :value="type.id"
            >
              {{ type.description }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryElk"
            :disabled="isWaitResult"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitResult"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">氣候事件</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table id="willProcessDisasterTable" :class="tableStyle">
                <thead class="table-dark">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">風景區</th>
                    <th scope="col">通報時間</th>
                    <th scope="col">警示項目</th>
                    <th scope="col">通報內容</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, key) in dataTableList"
                    :key="key"
                    :class="tableCenterStyle"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.ScenicAreaName }}</td>
                    <td>{{ getTime(item) }}</td>
                    <td>{{ getEvent(item) }}</td>
                    <td>{{ item.content }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- <div class="col">
          <div id="realAreaCarChart">
            <apexchart type="donut" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      table: null,
      startTime: moment().startOf("day").format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      typeList: [],
      selectType: -1,
      dataTableList: [],
      isWaitResult: false,
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),

    weatherStationScenicArea() {
      return this.scenicAreaList.filter(
        (s) =>
          s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO
      );
    },
    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },
  },
  watch: {
    selectScenicAreaId() {
      if (this.selectScenicAreaId !== -1) {
      }
    },
  },
  methods: {
    async queryCSV() {
      const list = await this.searchElk();
      if (Utils.isEmptyObject(list)) {
        return;
      }

      const csvContent = [["風景區", "通報時間", "警示項目", "通報內容"]];

      list.forEach((item) => {
        const row = [];
        row.push(item.ScenicAreaName);
        row.push(this.getTime(item));
        row.push(this.getEvent(item));
        row.push(item.content.replace(/\r\n|\n/g, "")); // 移除換行

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_災害通報.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
    },

    async queryElk() {
      this.dataTableList = await this.searchElk();
      this.updateTable();
    },

    async searchElk() {
      if (
        Utils.isEmptyObject(this.startTime) ||
        Utils.isEmptyObject(this.endTime)
      ) {
        alert("請選擇起訖時間");
        return;
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert("結束時間不可以小於開始時間");
        return;
      }

      const condition = {
        startTime: moment(this.startTime).startOf('minute').format(),
        endTime: moment(this.endTime).startOf('minute').format(),
        type: this.selectType,
      };

      let disasters = [];
      if (this.selectScenicAreaId === -1) {
        await this.$store.dispatch("disasterMonitor/getAllDisaster", condition);
        disasters = this.$store.getters["disasterMonitor/getAllDisaster"];
      } else {
        condition.id = this.selectScenicAreaId;
        await this.$store.dispatch(
          "disasterMonitor/getAreaDisaster",
          condition
        );
        disasters = this.$store.getters["disasterMonitor/getDisaster"];
      }

      Utils.setScenicAreaNamebyId(disasters);
      return disasters;
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.eventTime)) {
        return "-";
      }

      return moment(item.eventTime).format("YYYY/MM/DD HH:mm");
    },
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    getEvent(item) {
      const target = this.typeList.find(
        (type) => (type.enumType)=== item.conditionType
      );
      return target
        ? target.description === '豪雨' ? '豪雨' :  item.magnitudeValue + target.unit
        : "";
    },

    initTable: function () {
      this.table = $("#willProcessDisasterTable").DataTable({
    language: {
      url: '/json/dataTableZHTW.json'
    },
    "pageLength": 25,
    
    aoColumns: [    //控制每欄篩選與寬度
      { bSortable:  true ,"sWidth":"5%"}, 
      { bSortable: true ,"sWidth":"10%"},
      { bSortable:  true ,"sWidth":"15%"},
      { bSortable: true ,"sWidth":"15%"},
      { bSortable: false },
    ]
  });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.typeList = Object.values((CONST.CLIMATE_TYPE_ENUM));
    this.typeList.shift(); // 移除unknow
    this.updateTable();
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

tbody>tr>td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}

/* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
}

/* table不超過div */

#willProcessDisasterTable > thead > tr {
  text-align: center;
  vertical-align: middle;
}

#willProcessDisasterTable > tbody > tr {
  /* text-align: center; */
  vertical-align: middle;
}

/* 通報內容行 文字靠右 */
#willProcessDisasterTable > tbody > tr > td:nth-child(5) {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;

}


</style>
